import React from 'react';
import parse from 'html-react-parser';

const TextRenderer = ({text} : {text: string}) => {
    const transformedText: any = text ? text.replace(/\\r\\n/g, "<br>").replace(/\\\"/g, '"').replace(/\\\\/g, "\\").replace(/\\'/g, "'") : ""; 

    const lines: string[] = transformedText ? transformedText.split('\n') : [];


    return (
        <>
            {lines && lines.length && lines.length > 1 ? lines.map((line: string, index: number) => {
                    return <p key={index}>{parse(line)}</p>
                }) : 
                <>{text}</>
            }
        </>
    )
}

export default TextRenderer;